/* (ignored) */


//////////////////
// WEBPACK FOOTER
// http (ignored)
// module id = 2
// module chunks = 1